import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import * as bootstrap from "bootstrap";
import Pagination from "../../../components/private/pagination";
import SearchSelect from "../../../components/private/searchselect";


const Postulations = () => {
  const { token, authFetch } = useContext(AuthContext);

  const [postulations, setPostulations] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filtros
  const [filter, setFilter] = useState({ searchQuery: "", searchBy: "user" });
  const [stateFilter, setStateFilter] = useState("");

  // Paginación
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // Modal Bootstrap
  let modalInstance = null;

  const [curriculums, setCurriculums] = useState([]);
  const [offers, setOffers] = useState([]);

  const [formData, setFormData] = useState({
    IdUsuario: "",
    IdOfertas: "",
  });

  // ==========================================================
  // FUNCIONES
  // ==========================================================

  const getStateClass = (state) => {
    switch (state) {
      case "Aceptado":
        return "estado-aceptado";
      case "Denegado":
        return "estado-denegado";
      default:
        return "estado-proceso";
    }
  };

  const handleStateChange = async (id, newState) => {
    try {
      const response = await authFetch(ENDPOINTS.changeStatePostulation, {
        method: "POST",
        body: JSON.stringify({ id, state: newState }),
      });

      if (response.success) {
        setPostulations((prev) =>
          prev.map((p) =>
            p.IdPostulacion === id ? { ...p, state: newState } : p
          )
        );
      } else {
        alert(response.message || "No se pudo actualizar el estado");
      }
    } catch (error) {
      console.error(error);
      alert("Error de servidor");
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({ ...prev, [name]: value }));
    setCurrentPage(1);
  };

  const handleSearch = () => {
    if (!postulations || postulations.length === 0) return [];

    const query = filter.searchQuery.toLowerCase();

    return postulations.filter((post) => {
      let matchesText = false;

      switch (filter.searchBy) {
        case "user":
          matchesText = post.user_name?.toLowerCase().includes(query);
          break;
        case "offer":
          matchesText = post.nombreOferta?.toLowerCase().includes(query);
          break;
        default:
          matchesText = true;
      }

      const matchesState =
        stateFilter === "" ||
        post.state?.toLowerCase() === stateFilter.toLowerCase();

      return matchesText && matchesState;
    });
  };

  // PAGINACIÓN
  const filteredPostulations = handleSearch();
  const totalPages = Math.ceil(filteredPostulations.length / recordsPerPage);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };
  
  const currentPostulations = filteredPostulations.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  // ==========================================================
  // CARGA POSTULACIONES
  // ==========================================================
  useEffect(() => {
    if (!token) return;

    const loadPostulations = async () => {
      setLoading(true);
      try {
        const data = await authFetch(ENDPOINTS.GetPostulacion);

        if (data.success && data.data) setPostulations(data.data);
        else setPostulations([]);
      } catch (error) {
        console.error("Error al cargar postulaciones:", error);
        setPostulations([]);
      } finally {
        setLoading(false);
      }
    };

    loadPostulations();
  }, [token, authFetch]);

  // ==========================================================
  // MODAL BOOTSTRAP
  // ==========================================================

  const openModal = async () => {
    try {
      const curr = await authFetch(ENDPOINTS.getCurriculum);
      const off = await authFetch(ENDPOINTS.getActiveOffers);

      if (curr.success) setCurriculums(curr.data);
      if (off.success) setOffers(off.data);
    } catch (error) {
      console.error("Error cargando selects:", error);
    }

    const modalEl = document.getElementById("createPostulationModal");
    modalInstance = new bootstrap.Modal(modalEl);
    modalInstance.show();
  };

  const closeModal = () => {
    const modalEl = document.getElementById("createPostulationModal");
    modalInstance = bootstrap.Modal.getInstance(modalEl);
    modalInstance.hide();

    setFormData({ IdUsuario: "", IdOfertas: "" });
  };

  const handleCreatePostulation = async () => {
    if (!formData.IdUsuario || !formData.IdOfertas) {
      alert("Todos los campos son obligatorios");
      return;
    }

    try {
      const response = await authFetch(ENDPOINTS.addPostulation, {
        method: "POST",
        body: JSON.stringify(formData),
      });

      if (response.success) {
        alert("Postulación creada correctamente");
        closeModal();

        const reload = await authFetch(ENDPOINTS.GetPostulacion);
        if (reload.success) setPostulations(reload.data);
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.error(error);
      alert(error.message || "Error al crear postulación");
    }
  };

const userOptions = curriculums.map(c => ({
  value: c.document,
  label: `${c.document} - ${c.first_name} ${c.last_name}`
}));
const offerOptions = offers.map(o => ({
  value: o.IdOfertas,
  label: o.professional_program
}));
  // ==========================================================
  // RENDER
  // ==========================================================

  if (loading) return <p>Cargando postulaciones...</p>;

  return (
    <div className="container mt-4 p-4">
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Lista de Postulaciones</h2>

        <button className="btn btn-outline-pink" onClick={openModal}>
          <i className="bi bi-person-video2"></i> Crear Postulación
        </button>
      </div>

      {/* FILTROS */}
      <div className="row mb-3">
        <div className="col-md-5">
          <label className="m-1">Buscar por usuario u oferta</label>
          <input
            type="text"
            name="searchQuery"
            className="form-control"
            value={filter.searchQuery}
            onChange={handleFilterChange}
          />
        </div>

        <div className="col-md-4">
          <label className="m-1">Buscar en:</label>
          <select
            className="form-select"
            name="searchBy"
            value={filter.searchBy}
            onChange={handleFilterChange}
          >
            <option value="user">Usuario</option>
            <option value="offer">Oferta</option>
          </select>
        </div>

        <div className="col-md-3">
          <label className="m-1">Filtrar por estado:</label>
          <select
            className="form-select"
            value={stateFilter}
            onChange={(e) => setStateFilter(e.target.value)}
          >
            <option value="">Todos</option>
            <option value="En proceso">En proceso</option>
            <option value="Aceptado">Aceptado</option>
            <option value="Denegado">Denegado</option>
          </select>
        </div>
      </div>

      {/* TABLA */}
      {currentPostulations.length > 0 ? (
        <>
          <table className="table table-hover">
            <thead className="table-secondary">
              <tr>
                <th>Usuario</th>
                <th>Oferta</th>
                <th>Fecha</th>
                <th>Estado</th>
              </tr>
            </thead>

            <tbody>
              {currentPostulations.map((post) => (
                <tr key={post.IdPostulacion}>
                  <td>
                    {post.user_name} {post.user_last_name}
                  </td>
                  <td>{post.nombreOferta}</td>
                  <td>{new Date(post.created_at).toLocaleDateString("es-CO")}</td>

                  <td>
                    <select
                      className={`form-select form-select-sm ${getStateClass(
                        post.state
                      )}`}
                      value={post.state}
                      onChange={(e) =>
                        handleStateChange(post.IdPostulacion, e.target.value)
                      }
                    >
                      <option value="En proceso">En proceso</option>
                      <option value="Aceptado">Aceptado</option>
                      <option value="Denegado">Denegado</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* PAGINACIÓN */}
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />

        </>
      ) : (
        <p>No hay postulaciones registradas.</p>
      )}

      {/* ==========================================================
          MODAL BOOTSTRAP REAL
      ========================================================== */}

      <div
        className="modal fade"
        id="createPostulationModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Crear Postulación</h5>
              <button type="button" className="btn-close" onClick={closeModal}></button>
            </div>

            <div className="modal-body">
              <div className="mb-3">
                  <label>Seleccionar Usuario (curriculum)</label>

                  <SearchSelect
                    options={userOptions}
                    value={formData.IdUsuario}
                    onChange={(val) =>
                      setFormData(prev => ({ ...prev, IdUsuario: val }))
                    }
                    placeholder="Buscar usuario..."
                  />
                </div>


                <div className="mb-3">
                  <label>Seleccionar Oferta</label>
                  <SearchSelect
                      options={offerOptions}
                      value={formData.IdOfertas}
                      onChange={(val) =>
                        setFormData(prev => ({ ...prev, IdOfertas: val }))
                      }
                      placeholder="Buscar oferta..."
                    />
                </div>

            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closeModal}>
                Cancelar
              </button>
              <button
                className="btn btn-outline-pink"
                onClick={handleCreatePostulation}
              >
                Crear
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Postulations;
